import { _t } from "app/i18n/i18n";
import { unqiueElems } from "lib/utils";

// gets subcategory options for MenuFilterBar and sideBar FilterPanel
export const getSubCategories = (menuData, assetClass, region = "All", lang) => {
  if (!menuData) return [];

  const subCategories = menuData[`subCategories.${lang}`]
      .filter((row) => (assetClass !== "Home" ? row.category === assetClass : true))
      .filter((row) => row.regions.includes(region) || row.regions.includes("All"))
      .map((row) => row.subCategory);

  const subCategoriesWithHeader = [_t("All Categories"), ...subCategories];
  const uniqSubCategories = unqiueElems(subCategoriesWithHeader);
  return uniqSubCategories;
};
